import { kBiColorValues } from '@euler/app/components/message/widgets/bi-visualization/functions/biColors';
import { Typography } from '@euler/app/components/typography';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { BiColor, kBiColorNames } from '@euler/model/bi/viz';
import { memo } from 'react';
import { Pressable, View } from 'react-native';

const kColors = Object.values(BiColor);

/** Every theme color to pick from, and `自动` for the palette's. */
export const ColorChoices = memo(
  ({
    value,
    onPick,
  }: {
    value: BiColor | undefined;
    onPick: (color: BiColor | undefined) => void;
  }) => {
    const { rpx } = useResponsiveContext();
    const size = rpx(22);
    return (
      <View
        style={{
          flexDirection: 'row',
          flexWrap: 'wrap',
          alignItems: 'center',
          gap: rpx(6),
        }}
      >
        <Pressable
          accessibilityRole="radio"
          accessibilityLabel="自动配色"
          accessibilityState={{ checked: !value }}
          onPress={() => onPick(undefined)}
          style={{
            height: size,
            paddingHorizontal: rpx(8),
            borderRadius: size / 2,
            justifyContent: 'center',
            borderWidth: 1,
            borderColor: !value ? aiColors.primary : aiColors.border,
          }}
        >
          <Typography.Text
            size={rpx(11)}
            color={!value ? aiColors.primary : aiColors.foreground}
          >
            自动
          </Typography.Text>
        </Pressable>
        {kColors.map(color => (
          <Pressable
            key={color}
            accessibilityRole="radio"
            accessibilityLabel={kBiColorNames[color]}
            accessibilityState={{ checked: value === color }}
            onPress={() => onPick(color)}
            style={{
              width: size,
              height: size,
              borderRadius: size / 2,
              padding: rpx(2),
              borderWidth: 2,
              borderColor:
                value === color ? aiColors.foreground : 'transparent',
            }}
          >
            <View
              style={{
                flex: 1,
                borderRadius: size / 2,
                backgroundColor: kBiColorValues[color],
              }}
            />
          </Pressable>
        ))}
      </View>
    );
  },
);
